/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/first */
//declare var truste: any;
/*eslint-disable */
import React, { FC, ReactElement } from 'react';
import withLocalization from '../../hoc/withLocalization';
import './OfferFooter.scss';
//import houseLogo from '../../../features/siteTheme/Brands/tmvcs/logo/tmvc-house.svg';
//import path from '../../../features/siteTheme/Brands/tmvcs/logo/intlFooterLogo.svg';
import { replaceAllPlaceholder } from '../../../util/CommonLogic';
import ParseHtml from '../ParseHtml';
import { useMediaQuery } from 'react-responsive';
const OfferFooter: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const isAsia = window.location?.origin.includes('book.marriottvacationclub.asia') ? true : false;
  const disclaimerText = isAsia
    ? localize('preview-sales-engine.static-content.copy.footer.ap-disclaimer')
    : localize('preview-sales-engine.static-content.copy.footer.me-disclaimer');
  const timeshareDisText = isAsia
    ? localize('preview-sales-engine.static-content.copy.footer.ap-timeshare-disclaimer')
    : localize('preview-sales-engine.static-content.copy.footer.me-timeshare-disclaimer');
  const footerLink = isAsia
    ? localize('preview-sales-engine.static-content.copy.footer.asia-footer-links')
    : localize('preview-sales-engine.static-content.copy.footer.me-footer-links');
  const isMobile = useMediaQuery({ query: `(max-width: 500px)` });
  const path =
    'https://content-stg.vistana.com/files/live/sites/vistana-digital-content-manager/files/images/brand-logos/PBE2-748_TMVC-3upLogo_TMVCwhat-201370_White_1300.png';
  const footerLinkText = footerLink;
  const removePipeText = replaceAllPlaceholder(footerLinkText, '|', '');
  const finalFooterLink = replaceAllPlaceholder(removePipeText, '&nbsp;', '');
  return (
    <React.Fragment>
      <>
        <footer className="mainFooterWrapper">
          <div className="logoFooterWrapper">
            <div className="ftBrandLogoWrapper">
              <img src={path} alt={'brand-logo'} className="img-fluid" />
            </div>
          </div>
          <div className="bottomFooterWrapper">
            <div className="bottomTextContentFooter">
              <p
                dangerouslySetInnerHTML={{
                  __html: disclaimerText,
                }}
              ></p>
            </div>
            <div className="houseFooterContainer">
              {/* <img src={houseLogo} alt={'house-icon'} className="img-house" />*/}
              <div className="houseTextContainer">
                <div className="upperTextContainer">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: timeshareDisText,
                    }}
                  ></p>
                </div>
                <div className="LowerTextContainer">
                  {isMobile ? (
                    <>
                      <ParseHtml htmlInput={footerLink}></ParseHtml>
                      {/*<ParseHtml htmlInput={finalFooterLink}></ParseHtml>*/}
                    </>
                  ) : (
                    <>
                      <ParseHtml htmlInput={footerLink}></ParseHtml>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    </React.Fragment>
  );
};

export default React.memo(withLocalization(OfferFooter));
